import React from "react";
import logoKappa from "../../img/kappaLogo.png";
import Validation from "../../components/validation";
import { useLocation } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import ChatFlutuant from "../../components/ChatFlutuant";
import HeaderTopLinks from "../../components/headerTopLinks";

const Login: React.FC = () => {
  const { state } = useLocation();

  return (
    <div className="bgellipse">
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <HeaderTopLinks />
        <Divider variant="fullWidth" sx={{ borderBottomWidth: 2, borderColor: "#c5c5c5" }} />
        <div className="loginAcompanyBox">
          <Box width={{ xs: 300, md: 500 }}>
            <img src={logoKappa} style={{ width: "100%" }} />
          </Box>
          <Box mt={10} mb={5}>
            <p style={{ fontSize: 18 }}>Faça login para acessar a plataforma</p>
          </Box>
          <Validation pageDestiny={state} />
        </div>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "flex", md: "none" }} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} height={"100vh"} gap={5}>
        <Box width={{ xs: 300, md: 500 }}>
          <img src={logoKappa} style={{ width: "100%" }} />
        </Box>
        <Box mt={8}>
          <p style={{ fontSize: 18 }}>Faça login para acessar a plataforma</p>
        </Box>
        <Validation pageDestiny={state} />
      </Box>
      {/* Mobile */}

      <ChatFlutuant />
    </div>
  );
};

export default Login;
